<template>
	<vs-col vs-w="3" class="pr-4">
		<div class="vx-card mb-6" style="z-index: 500">
			<div class="p-6">
				<div class="flex items-center justify-between mb-4">
					<h5>Quick Search</h5>
					<div v-on:click="$emit('clear')" v-if="showClearFilter">
						<vx-tooltip text="Reset all filters" position="bottom" delay=".3s" class="flex items-center cursor-pointer">
							<feather-icon svgClasses="h-4 w-4 stroke-current" icon="TrashIcon" class="mr-2" />
								clear selection
						</vx-tooltip>
					</div>
				</div>

				Region
				<v-select
					multiple
					:closeOnSelect="true"
					v-model="filter.region"
					:options="catData.regionOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					placeholder="All Regions"
					class="mb-5"
				/>

				Date
				<datepicker
					:minimumView="'month'"
					:maximumView="'month'"
					format="MMM yyyy"
					v-model="filter.date"
					placeholder="All Dates"
					class="mb-5"
				></datepicker>

				Cruise Lines
				<v-select
					multiple
					:closeOnSelect="true"
					v-model="filter.cruiseLine"
					:options="catData.cruiseLineOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					placeholder="All Cruise Lines"
					class="mb-5"
				/>

				Cabin Type
				<v-select
					multiple
					:closeOnSelect="true"
					v-model="filter.cabinType"
					:options="catData.cabinTypeOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					placeholder="All Cabin Types"
					class="mb-5"
				/>

				Price per Person per Night: {{ filter.priceRange[0] }} to
				{{ filter.priceRange[1] }} USD
				<vs-slider
					ticks
					step="50"
					v-model="filter.priceRange"
					:min="0"
					:max="500"
					class="mb-8"
				/>

				<vs-button color="primary" type="filled" v-on:click="$emit('search')"
					>Search</vs-button
				>
			</div>
		</div>

		<div class="vx-card mb-6" style="z-index: 400">
			<div class="p-6">
				<h5 class="mb-4">What is Important?</h5>
				<ul class="">
					<li v-for="amenity in importantAmenities" :key="amenity.label">
						<vs-checkbox v-model="amenity.important" @change="updateImportantAmenities()" class="mx-0 my-2">{{
							amenity.label
						}}</vs-checkbox>
					</li>
				</ul>
			</div>
		</div>

		<div class="vx-card" style="z-index: 500">
			<div class="p-6">
				<div class="flex justify-between items-center">
					<h5>Duration: </h5>
					<div>{{ filter.duration[0] }} to {{ filter.duration[1] }} days</div>
				</div>
				<vs-slider
					ticks
					step="1"
					v-model="filter.duration"
					:min="1"
					:max="21"
					class="mb-8"
				/>

				<h5 class="mb-4">Ship Size</h5>
				<ul class="mb-5">
					<li>
                        <vs-radio v-model="ship" vs-value="s" >Small</vs-radio>
					</li>
					<li>
                        <vs-radio v-model="ship" vs-value="m">Medium</vs-radio>
					</li>
					<li>
                        <vs-radio v-model="ship" vs-value="l">Large</vs-radio>
					</li>
				</ul>
				<h5>Roundtrip</h5>
				<v-select label="" v-model="roundtrip" class="w-full mt-5 mb-2" :options="['Yes', 'No', 'Any']" />
			</div>
		</div>

	</vs-col>
</template>

<script>
import CatData from '@/components/cat/data.js'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue'

export default {
  components: {
    Datepicker,
    vSelect,
    VxAutoSuggest
  },

  props: {
    filter: {
      type: Object,
      required: true
    },
    nullFilter: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      catData: CatData,
      //temporary code
      ship: null,
      roundtrip: null,
      addressTypeOptions: [
        'Yes',
        'No',
        'Any'
      ]
    }
  },
  computed: {
    importantAmenities: {
      get () {
        const that = this
        return CatData.amenityOptions.map(function (a) {
          const isImportant = (that.filter.importantAmenities || []).includes(a)
          return { label: a, important: isImportant }
        })
      }
    },
    showClearFilter () {
      return JSON.stringify(this.filter) !== JSON.stringify(this.nullFilter)
    }
  },
  methods: {
    updateImportantAmenities () {
      this.filter.importantAmenities = this.importantAmenities
        .filter((a) => a.important === true)
        .map((a) => a.label)
    }
  }
}
</script>


<style lang="scss">
.con-vs-slider {
	min-width: 100px;
}
</style>
